export default __webpack_public_path__ + "static/media/headphone.d223dc03.png";